import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { IncidentLawEnforcementOOJModel } from '../../models/incident-law-enforcement-ooj.model';
import { LawEnforcementIncidentOOJService } from '../../services/law-enforcement-incident-ooj.service';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../../incident-modal.component';
import { CitingAgencyTypeService } from '../../services/citing-agency-type.service';
import { AccidentTypeService } from '../../services/accident-type.service';
import { IncidentService } from '../../services/incident.service';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '../../services/enums.DataService';

@Component({
    templateUrl: './law-enforcement-incident-ooj-modal.html'
})

export class LawEnforcementIncidentOOJModalComponent extends IncidentModalComponent<IncidentLawEnforcementOOJModel> {
    public bacRequired = false;
    public accidentTypes: any[];
    public oosJurisdictions: any[];
    public oosDriverLicenceJurisdictions: any[];
    public isLoadingIncident = false;

    constructor(
        public service: LawEnforcementIncidentOOJService,
        public dialogRef: MatDialogRef<IncidentModalComponent<IncidentLawEnforcementOOJModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<IncidentLawEnforcementOOJModel>,
        public citingAgencyTypeService: CitingAgencyTypeService,
        public accidentTypeService: AccidentTypeService,
        public incidentService: IncidentService,
        public prohibitionService: ProhibitionService,
        EnumDataService: EnumDataService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        modalService: MvdModalService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.hasCdlCheckboxOnForm = true;
    }

    protected onLoadLookups(callback: (error?) => void): void {
        if (this.incidentType.find(x => x.incidentTypeValue == 'A91').id) {
            if (this.data.incident.incidentTypeId == this.incidentType.find(x => x.incidentTypeValue == 'A91').id) {
                this.bacRequired = true;
            }
        }

        this.service.getLookups().subscribe(r => this.onGetLookups(r.result, callback), callback);
    }

    private onGetLookups(result: any, callback: (error?) => void): void {
        let lookups: any;
        lookups = result;
        this.accidentTypes = lookups.accidentTypes;
        this.oosDriverLicenceJurisdictions = lookups.vehicleJurisdictions;
        let baseJurisdiction = this.getBaseJurisdiction();
        this.oosJurisdictions = this.oosDriverLicenceJurisdictions.filter(x => x.value != baseJurisdiction.id);
        callback();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.isLoadingIncident = true;
        this.service.getIncident(this.data.incident.incidentNumberId)
            .subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: IncidentLawEnforcementOOJModel, callback: (error?) => void): void {
        this.isLoadingIncident = false;
        this.data.incident = incident;
        this.incidentForm.get('driverLicenseNumber').setValue(this.data.incident.driverLicenseNumber);
        this.showUserInput = true;


        if (this.data.incident.bac == 0) {
            this.data.incident.bac = null;

            try {
                this.incidentForm.get('bac').reset();
            } catch (Exception) { }
        }
        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        this.data.incident.driverLicenseNumber = this.incidentForm.get('driverLicenseNumber').value;
        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(_ => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }
}
